import { useEffect } from 'react';

import { logError } from '@iwLogger/IwDataDogLogger';
import { fetchPostPageView } from '@iwoca/lapi-client/edge';
import { getQueryParameter } from '@iwRouter/LocationHelper';

import { useStateKey } from '../iwQueryClient/useStateKey';

type TName =
    | 'Account History'
    | 'Apply Flexi Loan'
    | 'CBILS Dashboard'
    | 'Confirmed Funding'
    | 'Early Repayment'
    | 'Flexi-12 Dashboard'
    | 'Funding Requirements'
    | 'iwocaPay Dashboard'
    | 'My Offers'
    | 'Profile'
    | 'RBL Dashboard'
    | 'RLS Dashboard'
    | 'Second CBILS Dashboard'
    | 'Term Loan Dashboard'
    | 'Trading Data';

export const useTrackPageView = ({
    name,
    enabled = true
}: {
    name: TName;
    enabled?: boolean;
}) => {
    const stateKey = useStateKey();

    useEffect(() => {
        if (!enabled) return;

        trackPageView(stateKey, name);
    }, [stateKey, name, enabled]);
};

const trackPageView = (stateKey: string, name: string) => {
    const impersonatingStateKey = getQueryParameter(
        window.location,
        'state_key'
    );

    if (!impersonatingStateKey) {
        fetchPostPageView({
            stateKey: stateKey,
            body: { data: { name } }
        }).catch((exc) =>
            logError(`Page view for ${name} has not been logged.`, {
                exception: exc
            })
        );
    } else {
        console.warn(
            `Page View not tracked for impersonating user: ${stateKey}`
        );
    }
};
